import React, { useState } from "react";
import { CreateCompanyModalProps } from "./CreateCompanyModal";
import { CompanyFormState, CompanyFormState_default, CompanyFormState_toRequest } from "../../types/forms/CompanyFormState";
import { createCompanyAsync } from "../../apiClient";
import { showDangerAlert } from "../../common";

function useCreateCompanyModal(props: CreateCompanyModalProps) {
    const [formState, setFormState] = useState<CompanyFormState>(CompanyFormState_default());
    const [requestInProgress, setRequestInProgress] = useState(false);

    const disableSubmit = requestInProgress || !formState.name.value.trim();

    async function handleSubmitAsync(e: React.FormEvent) {
        e.preventDefault();

        const request = CompanyFormState_toRequest(formState);
        
        setRequestInProgress(true);
        const createResult = await createCompanyAsync(request);
        setRequestInProgress(false);

        if (createResult.failed) {
            console.error("Failed to create company. Request:", request, "Error:", createResult.error);
            const nameErrors = createResult.error.errors["Name"]

            const nameErrorMessage = nameErrors && nameErrors.length > 0 ? nameErrors[0] : undefined;

            if (!nameErrorMessage) {
                showDangerAlert(props.resources.get("CreateCompanyError") ?? "");
                return;
            } 

            setFormState(prevState => ({
                ...prevState,
                name: {
                    ...prevState.name,
                    errorMessage: nameErrorMessage
                }
            }))

            return;
        }

        props.onCompanyCreated(createResult.value.createdCompanyId);
    }

    function handleNameChange(name: string) {
        setFormState(prevState => ({
            ...prevState,
            name: { value: name, errorMessage: undefined }
        }));
    }

    function handleIsEnergyHarbourCustomerChange(isChecked: boolean) {
        setFormState(prevState => ({
            ...prevState,
            isEnergyHarbourCustomer: { value: isChecked, errorMessage: undefined }
        }));
    }

    return {
        formState,
        disableSubmit,
        handleSubmitAsync,
        handleNameChange,
        handleIsEnergyHarbourCustomerChange
    }
}

export default useCreateCompanyModal;
